export async function postToSalesforce({ pageUrl, campaignID, firstname, lastname, email }) {
  const headers = { "Content-Type": "application/x-www-form-urlencoded" };

  const params = new URLSearchParams({
    leadsource: "web",
    contactsource: pageUrl,
    firstname,
    lastname,
    email,
    campaignid: campaignID
  }).toString();

  try {
    const resp = await fetch(`https://cloud.email.obama.org/signup-autocomplete?${params}`, {
      method: "post",
      headers
    });

    if (resp.ok) {
      const body = await resp.json();
      // Validation errors from Salesforce Cloud Page are formatted with a 200 response,
      // but the bodies contain a status object with value `fail` and descriptive error msg.
      if (body.status === "fail") {
        throw new Error(body.msg);
      }
      return body;
    } else {
      throw new Error(`HTTP Error: ${resp.statusCode}`);
    }
  } catch (err) {
    /* eslint-disable no-console*/
    console.error(err);
    throw new Error(`Request Failed. ${err}`);
  }
}
